import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TarifarCont"},[_c(VBtn,{staticClass:"btn",attrs:{"text":"","rounded":""},on:{"click":function($event){return _vm.setModalRate(_vm.typeRate)}}},[_vm._v(" Tarifar "),_c('div',{staticClass:"iconCont"},[_c(VIcon,[_vm._v(" mdi-content-copy ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }